<template>
  <div>
    <div style="min-height: 25px" @click.stop="">
      <transition name="fade">
        <a v-show="isActive == false" class="text-gray-600 ml-3 selectCountry" @click.prevent="isActive = true">
          <template>
            <span class="font-3xl mr-1" style="line-height: 0.8em">+</span>
            <span>
              {{ $t(`backoffice.manage.balance.tables.components.select-country.title`) }}
            </span>
          </template>
        </a>
      </transition>
    </div>
    <transition name="fade">
      <div v-if="isActive">
        <CRow :gutters="false" class="d-flex align-items-center" @click.stop="">
          <CCol sm="8">
            <v-select
              ref="countrySelect"
              custom
              autoscroll
              class="mb-0 px-3 no-close"
              :options="countries"
              v-model="selectedCountry"
              :placeholder="$t('general.input.placeholder.select-country')"
              :dropdownShouldOpen="dropdownShouldOpen"
              @input="confirmAddCountry()"
            >
              <template #selected-option="{ label, flag }">
                <div class="d-flex align-items-center">
                  <img :src="flag" alt="" width="25" />
                  <span class="ml-2">{{ label }}</span>
                </div>
              </template>

              <template v-slot:option="option" class="py-4">
                <img :src="option.flag" width="30" height="auto" />
                <span class="ml-2">
                  {{ option.label }}
                </span>
              </template>
            </v-select>
          </CCol>
          <CCol>
            <CButton Button @click.prevent="cancelAddCountry">Cancel</CButton>
          </CCol>
        </CRow>
      </div>
    </transition>
  </div>
</template>

<script>
import { nameCountries } from '@/utils/countriesUtils.js'
import vSelect from 'vue-select'
export default {
  name: 'SelectCountry',
  components: {
    vSelect,
  },
  props: {
    removeCountries: {
      type: Array,
      default: () => [],
    },
    countriesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCountry: null,
      isActive: false,
    }
  },

  computed: {
    countries() {
      return nameCountries(this).filter(
        /*
         *  Caso não haja itens na countriesList, então lista tudo.
         *  Caso haja itens na countriesList, lista apenas os itens selecionados
         *  Não será listado os itens que estejam presentes na removeCountries
         */
        (item) => (this.countriesList.length == 0 || this.countriesList.includes(item.value)) && !this.removeCountries.includes(item.value),
      )
    },
  },

  methods: {
    selectCountry() {
      this.isActive = !this.isActive
    },

    dropdownShouldOpen(VueSelect) {
      if (this.isActive) {
        return VueSelect.open
      }

      return VueSelect.search.length !== 0 && VueSelect.open
    },
    cancelAddCountry() {
      this.selectedCountry = ''
      this.isActive = false
    },

    confirmAddCountry() {
      if (this.selectedCountry) {
        this.$emit('add-country', this.selectedCountry)
        setTimeout(() => {
          this.cancelAddCountry()
        }, 100)
      }
    },
  },
}
</script>

<style lang="scss" scope>
.selectCountry {
  &:hover {
    cursor: pointer;
  }
}
</style>
